import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/download/69af69fe886e10001485ef7b/ecr360_digital/src/components/ChatBot.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["AuthProvider"] */ "/home/ubuntu/download/69af69fe886e10001485ef7b/ecr360_digital/src/contexts/AuthContext.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["LanguageProvider"] */ "/home/ubuntu/download/69af69fe886e10001485ef7b/ecr360_digital/src/contexts/LanguageContext.tsx");
;
import(/* webpackMode: "eager" */ "/home/ubuntu/download/69af69fe886e10001485ef7b/ecr360_digital/src/styles/tailwind.css");
